import React, { useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Checkbox,
  FormGroup,
  FormControlLabel,
  Typography,
  Box,
  Button,
  Link,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { COLORS } from "../../constants";
import useSystemHook from "./../../hooks/SystemHook";
import {map, slice} from "lodash";

const FilterAccordion = ({
  sx,
  name,
  title,
  options,
  activeFilters,
  onFilterChange,
}) => {
  const [showAll, setShowAll] = useState(false);
  const visibleOptions = showAll ? options : slice(options, 0, 7);

  const { isMobile, isTablet, isDesktop } = useSystemHook();
  return (
    <Accordion defaultExpanded sx={{ boxShadow: "none" }}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon fontSize="small" />}
        sx={{ borderBottom: `1px solid ${COLORS.border}` }}
      >
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            variant="caption"
            edge="start"
            sx={{
              fontSize: isMobile
                ? "var(--font-size-xxs)"
                : "var(--font-size-s)",
              fontWeight: 500,
              textTransform: "uppercase",
              color: COLORS.darkText,
            }}
          >
            {title}
          </Typography>
          {!!activeFilters[name] && (
            <Link
              href="#"
              variant="caption"
              underline="hover"
              onClick={(e) => {
                e.preventDefault();
                onFilterChange({ target: { checked: false, name } });
              }}
              sx={{
                fontWeight: 500,
                color: COLORS.themeRed,
                fontSize: isMobile
                  ? "var(--font-size-xxs)"
                  : "var(--font-size-s)",
              }}
            >
              Clear
            </Link>
          )}
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <FormGroup>
          {map(visibleOptions, (option, index) => {
              return <FormControlLabel
                  key={index}
                  disableTypography
                  label={
                      <Typography variant="caption" sx={{ color: COLORS.lightText }}>
                          {option.text}
                      </Typography>
                  }
                  control={
                      <Checkbox
                          size="small"
                          checked={activeFilters[name] === option.value}
                          onChange={onFilterChange}
                          name={name}
                          value={option.value}
                          sx={{
                              color: `${COLORS.border} !important`,
                              "&.Mui-checked": {
                                  color: `${COLORS.themeRed} !important`,
                              },
                          }}
                      />
                  }
              />
          })}
          {options.length > 7 && !showAll && (
            <Button
              sx={{
                color: COLORS.themeRed,
                textDecoration: "underline",
                padding: 0,
                marginTop: 1,
                alignSelf: "flex-start",
                fontSize: isMobile
                  ? "var(--font-size-xxs)"
                  : "var(--font-size-s)",
              }}
              onClick={() => setShowAll(true)}
            >
              Show More
            </Button>
          )}
          {options.length > 7 && showAll && (
            <Button
              sx={{
                color: COLORS.themeRed,
                textDecoration: "underline",
                padding: 0,
                marginTop: 1,
                alignSelf: "flex-start",
                fontSize: isMobile
                  ? "var(--font-size-xxs)"
                  : "var(--font-size-s)",
              }}
              onClick={() => setShowAll(false)}
            >
              Show Less
            </Button>
          )}
        </FormGroup>
      </AccordionDetails>
    </Accordion>
  );
};

export default FilterAccordion;
